// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3865) return "static/chunks/3865-400cc875f4d5e998.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"540":"b67de598457b3f9d","7658":"907be4b9e17564ad","7980":"8b54f6fdb22f8d79"}[chunkId] + ".js";
};